import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import {
  EMAIL_SERVICE_PROVIDERS,
  SMS_SERVICE_PROVIDERS,
  SPARKPOST_PROVIDERS,
  SendingPlatform,
  ServiceProvidersBySendingPlatform,
} from '../constants';

export const is3rdPartySmsProvider = (esp: SERVICE_PROVIDERS) =>
  [SERVICE_PROVIDERS.TELNYX, SERVICE_PROVIDERS.TWILIO].includes(esp);

export const isSmsProvider = (esp: SERVICE_PROVIDERS) => SMS_SERVICE_PROVIDERS.includes(esp);

export const isEmailProvider = (esp: SERVICE_PROVIDERS) => EMAIL_SERVICE_PROVIDERS.includes(esp);

export const isSparkPostProvider = (esp: SERVICE_PROVIDERS) => SPARKPOST_PROVIDERS.includes(esp);

export const shouldShowAccountType = (
  sendingPlatform: SendingPlatform,
  espDefinitions: SERVICE_PROVIDERS[],
) => {
  const serviceProviders = ServiceProvidersBySendingPlatform[sendingPlatform];
  const availableServiceProviders = espDefinitions.filter((esp) => serviceProviders.includes(esp));
  return availableServiceProviders.length > 1;
};
